module.exports = __webpack_public_path__ + "static/team-35-489d4ce791dc5ee16ea28acfccb023ff.jpg";